import { render, staticRenderFns } from "./orderBackCard.vue?vue&type=template&id=b64c4230&"
import script from "./orderBackCard.vue?vue&type=script&lang=js&"
export * from "./orderBackCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports